module.exports = __webpack_public_path__ + "img/取消绑定.cb0e21dd.svg";